<template>
  <div>
    <div class="meal_detail" v-if="!loading">
      <div
        class="image"
        :style="'background-image: url(' + meal.url + ');'"
      ></div>
      <div class="meal">
        <div class="details">
          <div class="title">{{ meal.title }}</div>
          <div class="desc">{{ meal.desc }}</div>
          <br/>
          <div class="small">All Meals Include Bread Of The Day, Fresh Fruit, Pastry Of Choice & Variety Drinks (Oatmeal & Grits Upon Request)</div>
          <div class="action">
            <div class="each">
              <router-link :to="'/' + mealType" class="back"><i class="pi pi-angle-left"></i> back</router-link>
            </div>
            <div class="each">
              <Button
                @click="orderMeal()"
                label="Order"
                icon="pi pi-plus"
                iconPos="right"
                class="p-button-raised"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fb_db } from "../firebase";

export default {
  name: "MealDetail",
  data() {
    return {
      loading: true,
      meal: {},
    };
  },
  async mounted() {
    await this.getMeal();
    this.loading = false;
  },
  methods: {
    async getMeal() {
      const doc = await fb_db
        .collection("meals")
        .doc(this.$route.params.id)
        .get();
      if (!doc.exists) {
        console.log("No such document!");
      } else {
        this.meal = doc.data();
        this.meal.id = doc.id;
      }
    },
    async orderMeal() {
      console.log("ordered this meal..");
      const data = {
        status: "Open",
        week: 1,
        day: 1,
        meal: this.meal.id,
        ts: new Date(),
        type: this.mealType,
        user: this.$store.state.currentUser.uid,
      };
      const res = await fb_db.collection("orders").add(data);
      data.id = res.id;
      this.$router.push("/" + this.mealType);
    },
  },
  computed: {
    mealType() {
      return this.$route.meta.mealtype;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

.meal_detail {
  width: 100%;
  background: $white;
  //border-radius: 25px 0px 0px 0px;
  color: $text;

  .image {
    width: 100%;
    height: 30vh;
    //border-radius: 25px 0px 0px 0px;
    background-color: #efefef;
    margin-right: 15px;
    background-size: cover;
    background-position: center;
  }

  .meal {
    text-align: left;
    padding: 15px 15px;
    background: $white;
    border-radius: 25px 0px 0px 0px;

    .title {
      font-size: 22px;
      margin-bottom: 5px;
    }

    .desc {
      font-size: 12px;
    }

    .small {
      font-size: 10px;
    }

    .action {
      display: flex;
      height: 100%;
      justify-content: space-evenly;
      align-items: flex-end;
      margin-top: 20px;

      .each {
        width: 80px;
        height: 50px;
        text-align: center;
        line-height: 40px;
      }
    }
  }
}
</style>